import { ApiParameter, del, get, post } from "@insite/client-framework/Services/ApiService";
import { EventRegistrationModel } from "@tCooneyBrothers/ApiModels";

const eventRegistrationUrl = "api/v2/emailnew";

export async function getEventRegistrationForm() {
    try {
        const fieldCollection = await get<EventRegistrationModel[]>(`${eventRegistrationUrl}`, {})
            .then(response => {
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return fieldCollection;
        // eslint-disable-next-line no-empty
    } catch (error) { }
}

export function addEventRegistrationFields(parameter: EventRegistrationModel) {
    return post<EventRegistrationModel>(eventRegistrationUrl, parameter);
}
